import { sellerAPI } from './seller-api';
import { sellerPropertyAPI } from './seller-property-api';
import { Seller, SellerProperty } from '../types/seller';

const joeBrownSeller: Seller = {
  id: 'seller-joe-brown-001',
  name: 'Joe Brown',
  email: 'joe.brown@example.com',
  phone: '+27 83 555 1234',
  registeredDate: '2025-01-15',
  propertiesListed: 3,
  propertiesApproved: 0,
  status: 'active',
};

const joeBrownProperties: SellerProperty[] = [
  {
    id: 'sp-joe-001',
    sellerId: 'seller-joe-brown-001',
    title: 'Stunning Villa in Camps Bay with Ocean Views',
    description: 'Breathtaking 5-bedroom luxury villa with panoramic ocean views. Features include infinity pool, home cinema, wine cellar, and direct beach access. Modern architecture with premium finishes throughout. Perfect for entertaining with open-plan living areas flowing onto expansive outdoor terraces.',
    price: 18500000,
    location: {
      address: '47 Victoria Road',
      city: 'Camps Bay',
      province: 'Western Cape',
    },
    bedrooms: 5,
    bathrooms: 4,
    parkingSpaces: 4,
    size: 650,
    propertyType: 'House',
    listingType: 'For Sale',
    features: [
      'Ocean Views',
      'Infinity Pool',
      'Home Cinema',
      'Wine Cellar',
      'Beach Access',
      'Security System',
      '4 Garages',
      'Study',
      'Gym',
      'Staff Quarters'
    ],
    images: [],
    status: 'pending',
    createdDate: new Date().toISOString(),
    salesStage: 'listed',
    leadCount: 0,
    viewings: [],
  },
  {
    id: 'sp-joe-002',
    sellerId: 'seller-joe-brown-001',
    title: 'Modern Apartment in Sandton City Centre',
    description: 'Sophisticated 3-bedroom penthouse apartment in the heart of Sandton. Features floor-to-ceiling windows, designer kitchen with Miele appliances, marble bathrooms, and expansive balcony. Located in a secure building with concierge, gym, and pool. Walking distance to Sandton City and Gautrain station.',
    price: 4850000,
    location: {
      address: '88 Maude Street',
      city: 'Sandton',
      province: 'Gauteng',
    },
    bedrooms: 3,
    bathrooms: 2,
    parkingSpaces: 3,
    size: 185,
    propertyType: 'Apartment',
    listingType: 'For Sale',
    features: [
      'Penthouse',
      'City Views',
      'Balcony',
      'Concierge',
      'Gym',
      'Pool',
      '24/7 Security',
      'Air Conditioning',
      'Fiber Internet',
      'Underground Parking'
    ],
    images: [],
    status: 'pending',
    createdDate: new Date().toISOString(),
    salesStage: 'listed',
    leadCount: 0,
    viewings: [],
  },
  {
    id: 'sp-joe-003',
    sellerId: 'seller-joe-brown-001',
    title: 'Charming Family Home in Constantia with Wine Estate',
    description: 'Beautiful 4-bedroom Cape Dutch style home on 2 hectares with established vineyards. Features include gourmet kitchen, multiple living areas, master suite with spa bathroom, home office, and separate guest cottage. The property includes a small wine cellar and tasting room. Surrounded by magnificent mountain views and mature gardens.',
    price: 12500000,
    location: {
      address: '156 Spaanschemat River Road',
      city: 'Constantia',
      province: 'Western Cape',
    },
    bedrooms: 4,
    bathrooms: 3,
    parkingSpaces: 3,
    size: 450,
    propertyType: 'House',
    listingType: 'For Sale',
    features: [
      'Vineyard',
      'Wine Cellar',
      'Guest Cottage',
      'Mountain Views',
      'Large Garden',
      'Pool',
      'Home Office',
      'Fireplace',
      'Security',
      'Irrigation System',
      'Tasting Room'
    ],
    images: [],
    status: 'pending',
    createdDate: new Date().toISOString(),
    salesStage: 'listed',
    leadCount: 0,
    viewings: [],
  },
];

export async function seedJoeBrown() {
  try {
    console.log('🌱 Seeding Joe Brown and properties...');
    
    // Seed the seller
    console.log('Creating seller: Joe Brown');
    await sellerAPI.seedSellers([joeBrownSeller]);
    
    // Seed the properties
    console.log('Creating 3 properties for Joe Brown');
    await sellerPropertyAPI.seedSellerProperties(joeBrownProperties);
    
    console.log('✅ Joe Brown and properties seeded successfully!');
    console.log('📊 Summary:');
    console.log('  - Seller: Joe Brown (joe.brown@example.com)');
    console.log('  - Property 1: Villa in Camps Bay - R18.5M');
    console.log('  - Property 2: Penthouse in Sandton - R4.85M');
    console.log('  - Property 3: Wine Estate in Constantia - R12.5M');
    console.log('  - All properties are pending approval');
    
    return true;
  } catch (error) {
    console.error('❌ Error seeding Joe Brown:', error);
    throw error;
  }
}
